import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../static/common/mp-code.png';
const _hoisted_1 = {
  class: "follow-box"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title wow fadeInUp\">合作联系方式</div><div class=\"des wow fadeInUp\">服务保障，让你无后顾之忧！</div><div class=\"content\"><img class=\"image wow fadeInUp\" src=\"" + _imports_0 + "\"><div class=\"text wow fadeInUp\">扫码关注公众号了解更多</div></div>", 3);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Application = _resolveComponent("Application");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "botton wow fadeInUp",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.showDialog && _ctx.showDialog(...args))
  }, "立即咨询"), _createVNode(_component_Application, {
    ref: "application"
  }, null, 512)]);
}